import React, { useEffect, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { Space } from "antd";
import DataTable from "../../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UserOrganizationListAction } from "../../../actions/user";
import { formatMobileNumber, formatToCST } from "../../../utils/comman";

const OrganizationList = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const user = useSelector((state: any) => state?.Auth?.user);
  const roleId = user?.user?.roleId;
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dispatch = useDispatch<any>();

  const fetchOrganizationList = (params = {}) => {
    setLoading(true);
    // Always include current sort parameters in the request
    const requestParams = {
      ...params,
    };
    dispatch(
      UserOrganizationListAction(requestParams, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          setData(resp.data || []);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    fetchOrganizationList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
    });
  }, [handleRefresh]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    fetchOrganizationList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const handleViewOrganization = (record) => {
    if (roleId === 2) {
      navigate(`/leader/view-organization/${record.id}`);
    } else if (roleId === 3) {
      navigate(`/controller/view-organization/${record.id}`);
    } else {
      navigate(`/view-organization/${record.id}`);
    }
  };

  const columns = [
    {
      title: "Organization",
      dataIndex: "name",
      key: "name",
      render: (name: any, record: any) => {
        return `${record.shortCode || "N/A"}`;
      },
      sorter: true,
    },
    {
      title: "Division of",
      dataIndex: "divisionOf",
      key: "parentOrganization",
      render: (text, record) => {
        return record?.parentOrganization?.shortCode || "-";
      },
      sorter: true,
    },
    {
      title: "Org Leader",
      dataIndex: "leader",
      key: "name",
      render: (text, record) => {
        return (
          record?.organizationAssignment[0]?.leaderAndControllerDetails?.leader
            ?.name || "-"
        );
      },
      sorter: true,
    },
    {
      title: "Org Leader Email",
      dataIndex: "primare_contact_name",
      key: "primare_contact_name",
      render: (text, record) => {
        return (
          record?.organizationAssignment[0]?.leaderAndControllerDetails?.leader
            ?.email || "-"
        );
      },
    },
    {
      title: "Phone",
      dataIndex: "primare_contact_phone",
      key: "primare_contact_phone",
      render: (data) => formatMobileNumber(data),
    },
    {
      title: "Assigned On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: any) => formatToCST(date),
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EyeOutlined onClick={() => handleViewOrganization(record)} />
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* <Header /> */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Organizations</h1>

        {/* <Button type="primary" onClick={() => handleAddOrganization()}>
          Add Organization
        </Button> */}
      </div>
      <div className="table-col">
        <DataTable
          columns={columns}
          data={data}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default OrganizationList;
